export default __webpack_public_path__ + "static/media/Vambraces of the Chaos Agent.d872477a.jpg";